import { type DocumentData, doc, serverTimestamp, setDoc } from 'firebase/firestore';

import { getFirebaseDb } from '../app';
import { getDocument, subscribeToDocument, updateDocument } from '../firestore';

const COLLECTION = 'users';

export async function getUser(userId: string): Promise<(DocumentData & { id: string }) | null> {
  return getDocument(COLLECTION, userId);
}

export async function createUser(
  uid: string,
  data: Record<string, unknown>,
): Promise<void> {
  const db = getFirebaseDb();
  const userRef = doc(db, COLLECTION, uid);
  await setDoc(userRef, {
    uid,
    createdAt: serverTimestamp(),
    ownedOfficeIds: [],
    productTours: {
      onboarding: {
        closed: false,
        finished: false,
        lastStepId: null,
        steps: {},
      },
    },
    ...data,
  });
}

export async function updateUser(
  userId: string,
  data: Record<string, unknown>,
): Promise<void> {
  return updateDocument(COLLECTION, userId, data);
}

export function subscribeToUser(
  userId: string,
  callback: (data: (DocumentData & { id: string }) | null) => void,
): () => void {
  return subscribeToDocument(COLLECTION, userId, callback);
}
